<template>
  <sui-segment attached="bottom">
    <sui-table celled padded>
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell colspan="5">Hosting providers</sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body v-show="providersByPurpose.hosting.length">
        <sui-table-row v-for="provider in providersByPurpose.hosting" :key="provider.id">
          <sui-table-cell collapsing>
            <Logo class="provider-logo" :entity="provider" />
            <span class="provider-type">{{provider.type}}</span>
          </sui-table-cell>
          <sui-table-cell>
            <sui-button size="mini" color="orange" v-if="provider.expired" style="float: right; margin: -0.7em 0" @click="$modals.updateProvider.open(provider)">Refresh token</sui-button>
            {{provider.name}}
          </sui-table-cell>
          <sui-table-cell collapsing>
            <sui-dropdown selection :class="{disabled: !hostsByProvider[provider.id].length}">
              <span class="text">used for {{pluralize('host', hostsByProvider[provider.id].length, true)}}</span>
              <sui-dropdown-menu>
                <router-link class="item" :to="`/hosts/${host.name}`" v-for="host in hostsByProvider[provider.id]" :key="host.id">
                  <Logo :entity="host" />
                  {{host.name}}
                  <span class="description"><i class="arrow right icon" /></span>
                </router-link>
              </sui-dropdown-menu>
            </sui-dropdown>
          </sui-table-cell>
          <sui-table-cell collapsing>
            <time class="meta">added {{momentFromNow(provider.created)}}</time>
          </sui-table-cell>
          <sui-table-cell collapsing>
            <i class="trash fitted link icon" :class="{disabled: !access.providerDestroy}" @click="deleteProvider(provider)" />
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-body v-show="!providersByPurpose.hosting.length">
        <sui-table-row>
          <sui-table-cell colspan="5">You haven't added any hosting providers yet</sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell colspan="5">Storage providers</sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body v-show="providersByPurpose.storage.length">
        <sui-table-row v-for="provider in providersByPurpose.storage" :key="provider.id">
          <sui-table-cell collapsing>
            <Logo class="provider-logo" :entity="provider" />
            <span class="provider-type">{{provider.type}}</span>
          </sui-table-cell>
          <sui-table-cell>
            {{provider.name}}
          </sui-table-cell>
          <sui-table-cell collapsing>
            <sui-dropdown selection :class="{disabled: !servicesByProvider[provider.id].length}">
              <span class="text">used in {{pluralize('service', servicesByProvider[provider.id].length, true)}}</span>
              <sui-dropdown-menu>
                <router-link class="item" :to="`/services/${service.name}`" v-for="service in servicesByProvider[provider.id]" :key="service.id">
                  <Logo :entity="service" />
                  {{service.name}}
                  <span class="description"><i class="arrow right icon" /></span>
                </router-link>
              </sui-dropdown-menu>
            </sui-dropdown>
          </sui-table-cell>
          <sui-table-cell collapsing>
            <time class="meta">added {{momentFromNow(provider.created)}}</time>
          </sui-table-cell>
          <sui-table-cell collapsing>
            <i class="trash fitted link icon" :class="{disabled: !access.providerDestroy}" @click="deleteProvider(provider)" />
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-body v-show="!providersByPurpose.storage.length">
        <sui-table-row>
          <sui-table-cell colspan="5">You haven't added any storage providers yet</sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell colspan="5">Log providers</sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body v-show="providersByPurpose.logs.length">
        <sui-table-row v-for="provider in providersByPurpose.logs" :key="provider.id">
          <sui-table-cell collapsing>
            <Logo class="provider-logo" :entity="provider" />
            <span class="provider-type">{{provider.type}}</span>
          </sui-table-cell>
          <sui-table-cell>
            {{provider.name}}
          </sui-table-cell>
          <sui-table-cell collapsing>
            <sui-dropdown selection :class="{disabled: !servicesByProvider[provider.id].length}">
              <span class="text">used by {{pluralize('service', servicesByProvider[provider.id].length, true)}}</span>
              <sui-dropdown-menu>
                <router-link class="item" :to="`/services/${service.name}`" v-for="service in servicesByProvider[provider.id]" :key="service.id">
                  <Logo :entity="service" />
                  {{service.name}}
                  <span class="description"><i class="arrow right icon" /></span>
                </router-link>
              </sui-dropdown-menu>
            </sui-dropdown>
          </sui-table-cell>
          <sui-table-cell collapsing>
            <time class="meta">added {{momentFromNow(provider.created)}}</time>
          </sui-table-cell>
          <sui-table-cell collapsing>
            <i class="trash fitted link icon" :class="{disabled: !access.providerDestroy}" @click="deleteProvider(provider)" />
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-body v-show="!providersByPurpose.logs.length">
        <sui-table-row>
          <sui-table-cell colspan="5">You haven't added any log providers yet</sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-footer>
        <sui-table-row>
          <sui-table-header-cell colspan="5">
            <sui-button color="green" size="small" icon="plus" label-position="left" :disabled="!access.providerCreate" data-goal="SETTINGS_PROVIDERS_ADD" @click.prevent="openProviderCreator()">Add provider</sui-button>
          </sui-table-header-cell>
        </sui-table-row>
      </sui-table-footer>
    </sui-table>
    <sui-message error v-if="apiErrors">
      {{apiErrors}}
    </sui-message>
  </sui-segment>
</template>

<script>
  import {mapGetters} from 'vuex'
  import utils from '@/utils'

  export default {
    name: 'SettingsProvidersView',
    data() {
      return {
        apiErrors: null,
      }
    },
    computed: {
      ...mapGetters(['access', 'hostsByProvider', 'servicesByProvider', 'providersByPurpose']),
    },
    methods: {
      deleteProvider(provider) {
        return this.$modals.confirm.open({
          text: `<p>You are going to delete <b>${provider.name}</b> provider.</p>`,
          callback: () => {
            this.apiErrors = null
            utils.reachGoal('SETTINGS_PROVIDERS_DELETE_TRY')
            provider.destroy().then(() => {
              utils.reachGoal('SETTINGS_PROVIDERS_DELETE_SUCCESS')
            }).catch(error => {
              utils.reachGoal('SETTINGS_PROVIDERS_DELETE_FAIL')
              this.apiErrors = error
            })
          },
        })
      },
      openProviderCreator() {
        this.$modals.createProvider.open()
      },
    },
  }
</script>

<style scoped>
  .dropdown { border: none!important; margin: -1em; }
  .provider-logo { display: inline-block!important; margin: -1em 0!important; max-height: 2em!important; vertical-align: middle; }
  .provider-type { vertical-align: middle; }
  .trash:hover { color: #c00; }
</style>
